import { useState, ReactNode, FC } from 'react'

import LikeContext from '../../context/LikeContext'
import useGetLikes from '../../hooks/useGetLikes'

import { ILike } from '../../constants/types/common.types'

interface ILikeWrap {
  children: ReactNode
}

const LikeWrap: FC<ILikeWrap> = ({ children }: ILikeWrap) => {
  const [status, setStatus] = useState<ILike>({
    likeCount: '',
    like: false,
  })

  useGetLikes('', setStatus)

  return <LikeContext.Provider value={{ status, setStatus }}>{children}</LikeContext.Provider>
}

export default LikeWrap
